import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/response-model/api-response';
import { Payout } from 'src/app/models/payout.model';
import { PaginationFilterInput } from 'src/app/models/request-models/pagination-review-response';
import { ApplicationApiUrls } from 'src/app/constants/api-url-constants';
import { ChangePayoutStatusRequest } from 'src/app/models/request-models/change-payout-status-request';
import { ExtendedBaseInterface } from 'src/app/store/auth/auth.models';

@Injectable({
  providedIn: 'root',
})
export class PayoutsApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  createPayout(request: Payout): Observable<ApiResponse<Payout>> {
    return this.http.post<ApiResponse<Payout>>(`${this.apiUrl}${ApplicationApiUrls.CreatePayout}`, request).pipe(
      map((response) => response),
      catchError((error) => this.handleError(error)),
    );
  }

  getPayoutById(id: number): Observable<Payout> {
    return this.http.get<ApiResponse<Payout>>(`${this.apiUrl}${ApplicationApiUrls.GetPayoutById}${id}`).pipe(
      map((response) => response.result!),
      catchError((error) => this.handleError(error)),
    );
  }

  changePayoutStatus(receiptUrl: File, obj: ChangePayoutStatusRequest): Observable<ApiResponse<boolean>> {
    const formData = new FormData();
    formData.append('receiptUrl', receiptUrl);
    formData.append('Status', obj.status);

    return this.http.put<ApiResponse<boolean>>(`${this.apiUrl}/Payouts/${obj.id}/status`, formData).pipe(
      map((response) => response),
      catchError((error) => this.handleError(error)),
    );
  }

  getAllAdminPayout(filter: Partial<PaginationFilterInput>) {
    return this.http.get<ExtendedBaseInterface>(`${this.apiUrl}${ApplicationApiUrls.GetAllAdminPayout}`, {
      params: this.getPaginationParams(filter),
    });
  }

  getAllPayout(filter: Partial<PaginationFilterInput>) {
    return this.http.get<ExtendedBaseInterface>(`${this.apiUrl}${ApplicationApiUrls.GetAllPayout}`, {
      params: this.getPaginationParams(filter),
    });
  }

  deleteById(id: number): Observable<boolean> {
    return this.http.delete<ApiResponse<boolean>>(`${this.apiUrl} /Payouts/${id}`).pipe(
      map((response) => response.result!),
      catchError((error) => this.handleError(error)),
    );
  }

  private getPaginationParams(filter: Partial<PaginationFilterInput>): HttpParams {
    let params = new HttpParams();
    Object.keys(filter).forEach((key) => {
      if (filter[key] !== undefined && filter[key] !== null) {
        params = params.set(key, filter[key]!.toString());
      }
    });
    return params;
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }

  downloadRecepit(url: string, filename: string) {
    this.http.get(url, { responseType: 'blob' }).subscribe((blob) => {
      // Create a URL for the blob
      const blobUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = filename;

      // Trigger the download and cleanup
      anchor.click();
      window.URL.revokeObjectURL(blobUrl);
      anchor.remove();
    });
  }
}
